'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isPrimitive;
/**
 * Check if a value is a _primitive_ (string, number, boolean)
 *
 * @param {*} param Value to be checked for a primitive type definition.
 * @returns {boolean} Returns `true` if the value is a primitive, otherwise `false`
 */
function isPrimitive(param) {
  var type = typeof param === 'undefined' ? 'undefined' : _typeof(param);
  return type === 'string' || type === 'number' || type === 'boolean';
}
//# sourceMappingURL=isPrimitive.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-utilizr/lib/isPrimitive.js
 ** module id = 319
 ** module chunks = 0
 **/